<template>
<b-row class="m-2">
    <b-col v-if="loaded === false">
         <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else >
        <b-row>
            <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>
            <b-col>
                <h1>{{ecmResourceStrings.ttlConfigurations}}</h1>
            </b-col>
            <b-col class="text-right OTbtnContainer" cols="4">
                <b-dropdown text="Actions" right class="OTtableRowDropdown">
                    <b-dropdown-item v-for="action in actions" @click="onAction(action)" :key="action.name">
                        <span :class="'ot-icon-' + action.id" />{{ action.label }}
                    </b-dropdown-item>
                </b-dropdown>
            </b-col>
        </b-row>
         <b-row>
            <b-col class="OT-tabs">
                <SubNavbar :routes="routes"></SubNavbar>
            </b-col>
        </b-row>
        <b-row>
            <router-view :group="getname"></router-view>
        </b-row>
    </b-col>
</b-row>
</template>

<script>

import axios from 'axios';
import configRouteMappings from '@/ecm/routing/oticConfigRoutes.js';
import ECMErrorDialog from '../../modals/ECMCrawlerMessageDlg.vue';
import { showMessage} from '../../../utils/commonECM.js';
import SubNavbar from '@/ecm/components/settings/SubpageBar.vue';

export default {

    components: {
        SubNavbar,
        ECMErrorDialog,
    },

    data() {
        return {
            ecmResourceStrings: require('../../../utils/resourceECM.js'),  
            loaded: false,
            messageDlg: false,
            actions: [{
                name: 'verify',
                label: 'Verify',
                callback: this.verify
            },{
                name: 'test',
                label: 'Test Folder',
                callback: this.test
            },{
                name: 'export',
                label: 'Export',
                callback: this.onExport
            },{
                name: 'import',
                label: 'Import',
                callback: this.onImport
            }],
        }
    },

    computed: {
        routes() {
            const routes = configRouteMappings['OTIC Configurations'];
            return routes;
        },

        getname(){
            var that = this;
            return "General";
        },
    },

    methods: {

        onAction(action) {
            if (action.hasOwnProperty('callback')) {
                action.callback(action);
            }
        },

        verify(){
                this.$snotify.async(this.ecmResourceStrings.txtEcmStartingTestAPISettings, {
                timeout: 0
            });
            
            //start process test connection that takes Crawler connection parameters including user name and password 
            var that = this;
            const connString=that.createBodyPostString('-102');
            
            axios.post('/mtm-gateway-api/v1/services/ecm/actions/CrawlerRepositoryTestConnection', connString, 
                {headers: {"Content-Type": "application/json; charset=UTF-8"}})
            .then((res) => {
                /*this means the process run test is started. But we do not know whet the status is
                That is why now we are going to ask about status result*/
                that.getTestConnectionStatus('-102', '-1', true);
            })
            .catch((err) => {
                this.showError(err, 'validate', '-102');
            });
        },

        test(){
            /*Test Connection causes Attempts to write a sample file to the IngestionPipeline_HotFolder. */
            this.$snotify.async(this.ecmResourceStrings.txtEcmStartingTestFolder, {
                timeout: 0
            });
            
            //start process test connection that takes Crawler connection parameters including user name and password 
            var that = this;
            const connString=that.createBodyPostString('-100');
            
            axios.post('/mtm-gateway-api/v1/services/ecm/actions/CrawlerRepositoryTestConnection', connString, 
                {headers: {"Content-Type": "application/json; charset=UTF-8"}})
            .then((res) => {
                /*this means the process run test is started. But we do not know whet the status is
                That is why now we are going to ask about status result*/
                that.getTestConnectionStatus('-100', '-1', true);
            })
            .catch((err) => {
                this.showError(err, 'validate', '-100');
            });
        },

        createBodyPostString : function(id)
        {   // if (id == '-100') - test folder
            // if (id == '-102') - test API settings
            /*{
            "crawlerOperationDetails":[
            {"repositoryId":"",
            "operationType":"Idle",
            "operationMode":"Start",
            "operationStatus":"Idle",
            "engineName":"1",
            "actionStatusCode":"0",
            "actionStatusMessage":"",
            "executionStatusCode":"0",
            "executionFolderPathOrId":"",
            "executionComments":"",
            "jobId":""}]}*/
            const configstring = '{"repositoryId": ' + id + ', "operationType": "Idle", "operationMode": "Start", "operationStatus": "Idle", "engineName":"1", "partitionId":"-1", "ecmConnectionId": "-1", "actionStatusCode":"0", "actionStatusMessage":"" , "executionStatusCode":"0", "executionFolderPathOrId":"", "executionComments":"", "jobId":"" }';

            const connString = '{"crawlerOperationDetails":[' + configstring + ']}';

            return connString;
        },

        getTestConnectionStatus(id, jobid, showmessage)
        {///ifadmin/crawler/v2/actions/
            //get test results
            var that = this;
             axios.get('/mtm-gateway-api/v1/services/ecm/actions/CrawlerRepositoryTestConnection/' + id)
            .then((res) => {
                if (res.data) {
                    if(res.data.crawlerOperationDetails)
                    {
                        const operationStatus = res.data.crawlerOperationDetails[0].operationStatus;
                        if(operationStatus === 'Finished')
                        {
                            this.$snotify.clear();
                            var actionStatusMessage = '';
                            if(res.data.crawlerOperationDetails[0].actionStatusMessage != undefined)
                            {
                                actionStatusMessage  = res.data.crawlerOperationDetails[0].actionStatusMessage;
                                if(actionStatusMessage =='' || actionStatusMessage == null)
                                {
                                    if(res.data.crawlerOperationDetails[0].executionComments != undefined)
                                    {
                                        actionStatusMessage  = res.data.crawlerOperationDetails[0].executionComments;
                                    }
                                }
                            }
                            if(actionStatusMessage.length == 0)
                            {
                                if(showmessage == true)
                                {
                                    if (id == '-100')
                                    {
                                        this.$snotify.success(that.ecmResourceStrings.txtFolderTested);
                                    }
                                    else
                                    {
                                        this.$snotify.success(that.ecmResourceStrings.txtApiTested);
                                    }
                                }
                            }
                            else
                            {
                                var caption = '';
                                if (id == '-100')
                                {
                                    caption = that.ecmResourceStrings.ttlFolders;
                                } 
                                else
                                {
                                    caption = that.ecmResourceStrings.ttlAPISettings;
                                }

                                if(showmessage == true)
                                {
                                    showMessage(this, 'info', caption, '', true, actionStatusMessage);
                                }
                            }
                        }
                        else if(operationStatus === 'Error')
                        {
                            this.$snotify.clear();
                            var actionStatusMessage = '';
                            if(res.data.crawlerOperationDetails[0].actionStatusMessage != undefined)
                            {
                                actionStatusMessage  = res.data.crawlerOperationDetails[0].actionStatusMessage;

                                if(actionStatusMessage =='' || actionStatusMessage == null)
                                {
                                    if(res.data.crawlerOperationDetails[0].executionComments != undefined)
                                    {
                                        actionStatusMessage  = res.data.crawlerOperationDetails[0].executionComments;
                                    }
                                }
                            }
                            if(actionStatusMessage.length == 0)
                            {
                                actionStatusMessage = that.ecmResourceStrings.txtError;
                            }

                            var caption = '';
                            if (id == '-100')
                            {
                                caption = that.ecmResourceStrings.ttlFolders;
                            }
                            else
                            {
                                caption = that.ecmResourceStrings.ttlAPISettings;
                            }

                            if(showmessage == true)
                            {
                                //showMessage(this, 'error', caption, '', true, actionStatusMessage);
                            }
                            this.$snotify.error(caption, operationStatus, {
                            buttons: [
                                {text: this.ecmResourceStrings.txtViewDetails, action:()=>showMessage(this, 'error', caption, operationStatus, true, actionStatusMessage), bold: true },
                            ],
                        });
                        }
                        else
                        {
                            //not completed. Ask about status again
                            that.getTestConnectionStatus(id, jobid);
                        }
                    }
                }
            })
            .catch((err) => {
                this.showError(err, 'validate', id);
            });
        },

        onExport(){
           this.$snotify.async(this.ecmResourceStrings.txtEcmSettingsExportStart, {
                timeout: 0
            });
            var that = this;
            axios.get('/mtm-gateway-api/v1/services/ecm/config')
            .then((res) => {
                this.$snotify.clear();
                if (res.data) {
                    var i = 0;
                    for(i = 0; i < res.data.settingDetails.length; i++)
                    {
                        const dataOld = res.data.settingDetails[i].name;
                        if(dataOld == 'Dashboard_Password')
                        {
                            const val = res.data.settingDetails[i].value;
                            res.data.settingDetails[i].value = "*****"
                        }
                    }
               
                    var configs = res.data;
                    const data = JSON.stringify(configs);
                    const blob = new Blob([data], {type: 'text/plain'});
                            const e = document.createEvent('MouseEvents'),
                            a = document.createElement('a');
                    a.download = "ecmcrawlersettings.json";
                    a.href = window.URL.createObjectURL(blob);
                    a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
                    e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    a.dispatchEvent(e);
                    this.$snotify.clear();
                }}
            )
            .catch((err) => {
                this.showError(err, 'get');
                this.$snotify.clear();
                this.$snotify.error(this.ecmResourceStrings.txtEcmSettingsExportFail);
            });
        },

        onImport(){
           this.$router.push('/settings/otic-settings-import');
           return;
        },

        showError(err, location, id)
        {
            var sTitle='';
            if (id == '-100')
            {
                sTitle = this.ecmResourceStrings.ttlFolders;
            }
            else
            {
                sTitle =  this.ecmResourceStrings.ttlAPISettings;
            }

            this.$snotify.clear();
            if(err.response)
            {
                if(err.response.data)
                {
                    if(err.response.data.crawlerOperationDetails)
                    {
                        if(err.response.data.crawlerOperationDetails[0].actionStatusMessage != undefined)
                        {
                            const erdtstr = err.response.data.crawlerOperationDetails[0].actionStatusMessage;
                            this.$snotify.error(err.response.statusText, this.ecmResourceStrings.txtError, {
                            buttons: [
                                {text: this.ecmResourceStrings.txtViewDetails, action:()=>showMessage(this, 'error', sTitle, err.response.statusText, true, erdtstr), bold: true },
                            ],
                            });
                        }
                        else
                        {
                            this.$snotify.error(err.response.statusText);
                        }
                    }
                    else
                    {
                       if (id == '-100')
                        {
                            this.$snotify.error(this.ecmResourceStrings.errEcmFolderSettingVerify);
                        }
                        else
                        {
                            this.$snotify.error(this.ecmResourceStrings.errEcmAPISetting);
                        }
                    }
                }
                else if(err.message)
                {
                    this.$snotify.error(err.response.statusText, this.ecmResourceStrings.txtError, {
                        buttons: [
                            {text: this.ecmResourceStrings.txtViewDetails, action:()=>showMessage(this, 'error', sTitle, err.response.statusText, true, err.message), bold: true },
                        ],
                    });
                }
                else
                {
                    this.$snotify.error(err.response.statusText, this.ecmResourceStrings.txtError, {
                        buttons: [
                            {text: this.ecmResourceStrings.txtViewDetails, action:()=>showMessage(this, 'error', sTitle, err.response.statusText, false, ''), bold: true },
                        ],
                    });
                }
            }
            else
            {
                if (id == '-100')
                {
                    this.$snotify.error(this.ecmResourceStrings.errEcmFolderSettingVerify);
                }
                else
                {
                    this.$snotify.error(this.ecmResourceStrings.errEcmAPISetting);
                }
           }
        },
    },

    created() {
        var that = this;
        that.loaded = true;
    },
}
</script>
